export enum Tag {
    defensive,
    attack,
    range,
    utils,
    morale,
    resources,
    crowd_control,
    cooperation,
    sustained,
    support,
    stack,
    upgradeable,
    passive,
    can_learn_few_times,
    action,
    buff,
    upgrade,
    melee,
    once_per_fight,
    quick_action,
    debuff,
    aura,
    offensive,
    ulti
}

export enum SkillCategory {

}

export type SkillID = number
export type SkillDef = {
    id: SkillID,
    name: string,
    description: string,
    requirements: Requirements,
    tags: Tag[],
    required?: SkillID, 
    // category: SkillCategory,
    //
    children?: SkillDef[]
}

export type Requirements = {
    body: number,
    sharpeness: number,
    spirit: number
}

// umka która pozwala rzucać czary - z użyciem upadku zamiast skupienia
// duchowe powiązanie
// mechania grupy i bosów
// redukcja pancerza
// hunters mark like
// lepsze rozbrojenie
// łucznik ułatwia strzały
// uderzenie tarcza
//cień efekty leczące zadają obrażenia
//

// pasive skills: hp, hp_regen, 
export const rawSkills: SkillDef[] = [
    {
        id: 1020,
        name: "Formacja",
        description: `Jeśli walczysz w pierwszej linii razem z conajmniej jednym sojusznikiem zyskujesz 1 punkt pancerza 
        jeśli walczysz samotnie w pierwszej lini zadajesz 1 dodatkowe obrażenie.`,
        tags: [ Tag.passive, Tag.defensive, Tag.offensive],
        requirements: {
            body: 1,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1030,
        name: "Zaatakuj dwóch wrogów",
        description: `(Akcja) Jednym atakiem bronią białą atakujesz dwóch pobliskich przeciwników. 
        Mogą to być dwie postacie koło Ciebie lub dwie postaci stojące z Tobą w linii w zależności od rodzaju broni jakiego używasz. 
        Przed rzutem na Atak wybierz cel główny, który otrzymuje 100% obrażeń oraz poboczny, który otrzyma 50% obrażeń.`,
        tags: [Tag.action, Tag.attack],
        requirements: {
            body: 1,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1031,
        name: "Zaatakuj kilku wrogów",
        description: `Oprócz celu głownego który otrzymuje 100%, atakujesz dwa cele poboczne, z których jeden otrzymuje 100% a drugi 50% obrażeń.`,
        tags: [Tag.attack, Tag.action, Tag.upgrade],
        required: 1030,
        requirements: {
            body: 1,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1040,
        name: "Szarża",
        description: `(Akcja) Wykonujesz sarżę na wroga zakończoną atakiem. Atak wykonujesz ze skupieniem i zadaje on dodatkowe obrażenia równe Twojemu ciału.`,
        tags: [Tag.attack, Tag.action],
        requirements: {
            body: 1,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1041,
        name: "Zaawansowana szarża",
        description: `Szarżę możesz zakończyć inną zdolnością, która zadaje obrażenia jednemu wrogowi. 
        Nadal używasz skupienia i zwiększasz obrażenia o wartość Twojego Ciała.`,
        tags: [Tag.attack, Tag.action, Tag.upgrade],
        required: 1040,
        requirements: {
            body: 1,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1060,
        name: "Dobijanie",
        description: "Swoimi atakami zadajesz dodatkowe 2 obrażenia rannym przeciwnikom.",
        tags: [Tag.passive, Tag.offensive],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1061,
        name: "Skuteczniejsze dobijanie",
        description: "Swoimi atakami zadajesz dodatkowe 1-no obrażenie lekko rannym przeciwnikom, 2 rannym i 3 ciężko rannym.",
        tags: [Tag.passive, Tag.offensive, Tag.upgrade],
        required: 1060,
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1062,
        name: "Dobijanie - dodatkowe obrażenia",
        description: "Ciężko rannym przeciwniom Twoje ataki zadają dotatkowe 2 punkty obrażeń.",
        tags: [Tag.passive, Tag.offensive, Tag.upgrade],
        required: 1060,
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1063,
        name: "Dobijanie niefizyczne",
        description: "Obrażenia zadawane z w ramach Dobjania są niefizyczne.",
        tags: [Tag.passive, Tag.offensive, Tag.upgrade],
        required: 1060,
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 1
        }
    },
    {
        id: 1070,
        name: "Walka bez broni",
        description: "Ataki wykonywane bez broni zadają dodatkowe 2 obrażenia.",
        tags: [Tag.passive, Tag.offensive],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1071,
        name: "Dodatkowy cios",
        description: "Podczas swojej tury możesz wykonać kolejny atak bez broni.",
        tags: [Tag.offensive, Tag.upgrade],
        required: 1070,
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1072,
        name: "Furia ciosów",
        description: "Podczas swojej tury możesz wykonać kolejny atak bez broni.",
        tags: [Tag.offensive, Tag.upgrade],
        required: 1070,
        requirements: {
            body: 0,
            sharpeness: 3,
            spirit: 0
        }
    },
    {
        id: 1080,
        name: "Pewne strzały",
        description: "Zadajesz dodatkowe 2 obrażenia atakując z dystansu.",
        tags: [Tag.passive, Tag.range, Tag.can_learn_few_times],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },

    {
        id: 1081,
        name: "Przycelowanie", 
        description: "Jeżeli Akcja strzału jest jedyną czynnością wykonaną w tej turze zadajesz dodatkowe 5 obrażeń przy trafieniu.",
        tags: [Tag.range, Tag.passive],
        required: 1080,
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1090,
        name: "Szybkie strzały", 
        description: "Możesz wykonać tyle ataków na dystans ile wynosi Twoja Ostrość, ale wykonujesz je używając kości K12.",
        tags: [Tag.range, Tag.passive],
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1085,
        name: "Celność", 
        description: "Przy atakach dystansowych nie ropraszasz kości za dystans.",
        tags: [Tag.range, Tag.passive],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1100,
        name: "Pod ręką",
        description: "Możesz użyć jednego przedmiotu pod ręką zaraz po rozpoczęciu walki - jeszcze przed rzutem na inicjatywę",
        tags: [Tag.utils],
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1110,
        name: "Okrzyk",
        description: "(Akcja) W tej turze zapewniasz swoim sojusznikom skupienie kości podczas akcji ofensywnych lub defensywnych.",
        tags: [Tag.action, Tag.buff],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1130,
        name: "Jednostka",
        description: "Posiadasz towarzysza (nierozumnej rasy) np. zwierzę, robota, zombie o statystykach 1/0/0/0 lub 0/1/0/0",
        tags: [Tag.passive, Tag.utils, Tag.can_learn_few_times],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1132,
        name: "Ulepszone jednostki",
        description: "Twoje jednostki mają dodatkowy punkt Ciała lub Ostrości",
        tags: [Tag.buff, Tag.can_learn_few_times, Tag.passive],
        required: 1130,
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1133,
        name: "Uzbrojone jednostki",
        description: "Twoje jednostki mogą używac broni i pancerzy.",
        tags: [Tag.buff, Tag.can_learn_few_times, Tag.passive],
        required: 1130,
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1140,
        name: "Uzdrowienie",
        description: `(Akcja) Możesz na odległość przywrócić 2 + Dusza punktów życia sojusznikowi lub podwojoną wartość dotykając go albo lecząc siebie.`,
        tags: [Tag.action, Tag.support],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1141,
        name: "Lepsze uzdrawiwnie",
        description: "Bazowa wartość przywracanych przez Ciebie punktów życia wzrasta z 2 do 5.",
        tags: [Tag.support, Tag.upgrade],
        required: 1140,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 2
        }
    },
    {
        id: 1142,
        name: "Szybkie uzdrowienie",
        description: "Możesz użyć uzdrowienia jako Wtrącenia, ale nie będziesz mógł wtedy użyć go w swojej turze.",
        tags: [Tag.support, Tag.upgrade],
        required: 1140,
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1143,
        name: "Wskrzeszenie",
        description: `Raz na sesję możesz podjąć próbę zredukowania punktów upadku u siebie lub sojusznika. Rzuć kością Duszy przeciwko SŁ: 10.
            Przy sukcesie redukujesz 1 punkt Upadku, oraz dodakowy za każde dwa poziomy sukcesu.
        `,
        tags: [Tag.support, Tag.upgrade],
        required: 1140,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 3
        }
    },
    {
        id: 1144,
        name: "Masowe uzdrowienie",
        description: "Raz na dzień jako akcja możesz uzdrowić do 5 postaci w tym siebie, przywracając każdemu dwa razy tyle punktów życia ile leczysz na dystans.",
        tags: [Tag.support, Tag.upgrade, Tag.action],
        required: 1140,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 3
        }
    },
    {
        id: 1150,
        name: "Ulepszona dekoncentracja",
        description: `(Akcja) Udana dekoncentracja zadaje dodatkowo nieuchronne obrażenia równe stopniowi sukcesu.`,
        tags: [Tag.action, Tag.attack],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1160,
        name: "Niechybne obrażenia",
        description: "(Akcja) Wyknaj rzut sporny na Duszę przy sukcesie zadajesz 7 niechybnych obrażeń.",
        tags: [Tag.action, Tag.attack],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1170,
        name: "Śmierć",
        description: `(Akcja) Wykonaj test sporny na Duszę. Sukces: Dodaj do stopni sukcesu 5, jeśli aktualne życie przeciwnika jest równe lub mniejsze od tej wartości zostaje on pokonany.`,
        tags: [Tag.attack, Tag.action],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 2
        }
    },
    {
        id: 1180,
        name: "Niechybne obrażenia w czasie",
        description: `(Akcja) Wykonaj test sporny na Duszę, przy sukcesie nakładzasz 1(+1 za każde 3 stopnie sukcesu) punkt zepsucia. 
            Punkty zepsucia zadają niechybne obrażenia(równe punktom zepsucia) na koniec tury i nie znikają, kumulują się w nieskończoność.
            Żeby pozbyć się Zepsucia musisz oddalić się od ich źródła o 25m.`,
        tags: [Tag.action, Tag.attack, Tag.range],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 2
        }
    },
    {
        id: 1200,
        name: "Poświęcenie",
        description: `(Akcja) Zadeklaruj ile punktów życia chcesz poświęcić i zredukuj swoje życie o tę wartość, następnie wykonaj atak w zwarciu w standardowy sposób, przy trafieniu zadajesz dodatkowe obrażenia fizyczne w równe poświęconym punktom życia.`,
        tags: [Tag.action, Tag.attack, Tag.melee],
        requirements: {
            body: 2,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1201,
        required: 1200,
        name: "Precyzyjne poświęcenie",
        description: "Decyzje o ilości poświęconego zdrownia podejmujesz po trafieniu.",
        tags: [Tag.action, Tag.attack, Tag.melee],
        requirements: {
            body: 2,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1202,
        required: 1200,
        name: "Ostateczne poświęcenie",
        description: `Jeśli zaczynasz akcję poświęcenia będąc ranny zadajesz dodatkowe 1-no obrażenie za każde 2 poświęcone punkty życia. 
        Jeśli zaczynasz ją będąc ciężko ranny zadajesz dodatkowe 1-no obrażenie za każdy poświęcony pukty życia.`,
        tags: [Tag.action, Tag.attack, Tag.melee],
        requirements: {
            body: 2,
            sharpeness: 0,
            spirit: 0
        }
    },
    // zdrowy - 30 i więcej
    // lekko ranny - mniej niż 30ranny
    // ranny - mniej niż 20
    // ciężko ranny - mniej niż 10
    {
        id: 1210,
        name: "Rozproszenie",
        description: `(Wtrącenie) Możesz spróbować przeszkodzić przeciwnikowi w wykonaniu zdolności wymagającej Akcji, jeśli jest blisko Ciebie. 
        Wykonaj test sporny: Twoja Ostrość przeciwko statystyce która jest podstawą wykonywanej przez przeciwnika Akcji. Przy sukcesie przeciwnik traci możliwość wykonania jakiejkolwiek Akcji w tej turze.
        Jeśli nie uda Ci się przeciwnik jest odporny na Twoje Rozporoszenie do końca walki.`,
        tags: [Tag.quick_action, Tag.once_per_fight],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1211,
        name: "Rozproszenie na odległość",
        required: 1210,
        description: `Możesz wykonywać Rozproszenie na odległość`,
        tags: [Tag.quick_action, Tag.once_per_fight],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1212,
        name: "Duchowe rozproszenie",
        description: `Możesz wykonywać Rozproszenie używając Ducha zamiast Ostrości`,
        tags: [Tag.quick_action, Tag.once_per_fight],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 1
        }
    },
    {
        id: 1220,
        name: "Transformacja",
        description: "(Akcja) Transformujesz się a Twoje Ciało lub Ostrość wzrasta o 1 do końca walki. Można użyć wielokrotnie podczas jednej walki!",
        tags: [Tag.action, Tag.buff],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1221,
        name: "Ulepszona Transformacja",
        description: "Przy Transformacji możesz rozdać 2 punkty statystyk w Ciało i/lub Ostrość",
        tags: [Tag.buff, Tag.upgrade],
        required: 1220,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1230,
        name: "Lot",
        description: "Posiadasz możliwośc latania do 5m w zwyż przez minutę lub jedną walkę dziennie.",
        tags: [Tag.utils],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1231,
        name: "Ulepszony lot",
        description: "Możesz używać lotu w każdej walce lub przez godzinę dziennie.",
        tags: [Tag.utils, Tag.upgrade],
        required: 1230,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1240,
        name: "Odbijanie obrażeń",
        description: "Otrzymując obrażenia od fizycznych ataków przeciwnika w zwarciu zadajesz mu niechybne obrażenia równe Twojej Duszy.",
        tags: [Tag.passive],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1241,
        name: "Odbijanie obrażeń - zasięg",
        description: "Odbijanie obrażeń działa również na fizyczne ataki z dystansu.",
        tags: [Tag.passive, Tag.upgrade],
        required: 1240,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1242,
        name: "Odbijanie obrażeń - niefizyczne",
        description: "Odbijanie obrażeń działa również na niefizyczne ataki.",
        tags: [Tag.passive, Tag.upgrade],
        required: 1240,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 2
        }
    },
    {
        id: 1243,
        name: "Odbijanie obrażeń - zwiększone obrażenia",
        description: "Podwajasz odbijane obrażenia.",
        tags: [Tag.passive, Tag.upgrade],
        required: 1240,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1250,
        name: "Pocisk",
        description: "(Akcja) Wykonaj atak dystansowy zadający dodatkowe 5 obrażeń fizycznych przy trafieniu.",
        tags: [Tag.action, Tag.attack, Tag.range],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 1
        }
    },
    {
        id: 1251,
        name: "Ulepszony pocisk",
        description: "Twoje pociski zadają dodatkowe 3 obrażen fizycznych.",
        tags: [Tag.action, Tag.attack, Tag.range],
        required: 1250,
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 2
        }
    },
    {
        id: 1252,
        name: "Pociski",
        description: "Wypuszczasz 1 dodatkowy pocisk w ten sam cel. Oba pociski korzystają z tego samego wyniku ataku.",
        tags: [Tag.action, Tag.attack, Tag.range],
        required: 1250,
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 2
        }
    },
    {
        id: 1260,
        name: "Stożek",
        description: "(Akcja) Zadajesz obrażenia na obszaże stożka którego jesteś początkiem. Wykonaj test sporny: Twoja Dusza przeciwko Ostrości przeciwników, Ci którzy przegrali otrzymują 6 + stopnie sukcesu obrażeń niefizycznych.",
        tags: [Tag.action, Tag.attack, Tag.range],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1270,
        name: "Wybuch",
        description: `Tworzysz wybuch zadający obrażenia wszystkim postaciom w okręgu o promieniu 2m. 
        Wykonaj test sporny Dusza przeciwko Ostrości każdego wroga.
        Przy Twoim sukcesie przeciwnik otrzymuje 3 plus stopnie sukcesu obrażenia niefizyczne.`,
        tags: [Tag.action, Tag.attack, Tag.range],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1280,
        name: "Światło",
        description: `Generujesz źródło światła, którego podtrzymanie kosztuje 1 Many na turę. 
        Jako (Akcja) Możesz spróbować oślepić wrogów którzy Cię widzą.
        Wykonaj test sporny na Duszę w przypadku powodzenia przeciwnicy w nastepnej turze redukują kość do K20 na wszystkie testy związane ze wzrokiem w tym ataku i uników`,
        tags: [Tag.debuff, Tag.action],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1300,
        name: "Skwar",
        description: `(Akcja) Generujesz ciężki do zniesienia gorąc. 
        Co turę wszystkie postacie otrzymują 1 punkt obrażeń niefizycznych + 1 za ilość tur które spędziły pod tym wpływem.
         Minimalnie postać może otrzymać tyle obrażeń ile wynosi jej pancerz. 
         Podtrzymanie kosztuje 1 punkt Many + 1 za każdą postać wyłączoną z tego efektu.`,
        tags: [Tag.sustained, Tag.action, Tag.once_per_fight],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 3
        }
    },
    {
        id: 1310,
        name: "Duże obrażenia po czasie",
        description: `(Akcja) Rzuć kością Duszy wynik to liczba tur po których postacie stojące w wyznaczonym przez ciebie miejscu(miejsce wyznaczasz w turze rzucania zdolności) 2x2m otrzymają 100 obrażeń. 
        Nie możesz używać tej zdolności gdy już oczekujesz na jej efekt końcowy.`,
        tags: [Tag.action],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 3
        }
    },
    {
        id: 1320,
        name: "Telekineza",
        description: `Możesz używać przedmiotów na odległość. Używasz wtedy Duszy do testów związanych z ich manipulowaniem lub atakami. 
            Manipulacja przedmiotami wymaga użycia Many, Gap podejmuje decyzję jak dużo Many zużyje dany przedmiot.
        `,
        tags: [Tag.utils],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 2
        }
    },
    {
        id: 1330,
        name: "Przyciągnięcie",
        description: `(Akcja) Przywołujesz przedmiot, który po drodze do Twojej ręki zadaje obrażenia pierwszemu napotkanemu celowi. 
        Przy trafieniu wykonaj test sporny Twoja Dusza przeciwko Ostrości celu, stopnie sukcesu to obrażenia jakie otrzymuej cel. 
        Możesz przywoływać tylko przedmioty, które miałeś w ręku podczas walki.`,
        tags: [Tag.action, Tag.range],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1340,
        name: "Taniec ostrzy",
        description: "(Akcja) (Raz na walkę) Wykonujesz atak przeciwko każdej postaci którą już atakowałeś w tej walce.",
        tags: [Tag.attack, Tag.action],
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1350,
        name: "Wir",
        description: `(Akcja) Jako akcja aktywujesz Aurę, która na koniec Twojej tury zadaje niechybne obrażenia równe Twojej Duszy wrogom będących z Tobą w zwarciu. 
        Możesz zwiększyć poziom wiru co zwiększy zadawane obrażenia o Twoją Duszę na poziom.
         Podtrzymanie efektu kosztuje 1 many na turę za poziom wiru oraz akcję.`,
        tags: [Tag.aura],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1360,
        name: "Porażenie",
        description: "(Akcja) Wykonaj atak wręcz bez broni, zadający 5 dodatkowych obrażeń przy trafieniu. W przypadku perfekcyjnego trafienia przeciwnik dodatkowo traci następną turę.",
        tags: [Tag.action, Tag.attack],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1361,
        name: "Porażenie na dystans",
        description: "Możesz rzucić porażenie na przeciwnika którego widzisz w zasięgu 5 metrów.",
        tags: [Tag.upgrade, Tag.attack],
        required: 1360,
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1362,
        name: "Masowe porażenie",
        description: "Możesz rzucać porażenie na tyle osób ile wynosi Twoja Dusza.",
        tags: [Tag.upgrade],
        required: 1360,
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 2
        }
    },
    {
        id: 1370,
        name: "Natychmiastowa śmierć",
        description: "(Akcja) Wykonaj test sporny na Duszę, żeby nałożyć na przeciwnika tyle ładunków ile wynosi stopień sukcesu. Gdy zbierzesz 20 ładunków cel zostaje pokonany.",
        tags: [Tag.attack, Tag.action],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 3
        }
    },
    {
        id: 1380,
        name: "Tarcza",
        description: "Raz na turę możesz osłonić siebie lub sojusznika tarczą redukując nadchodzące obrażenia o wartośc równą Twojej Duszy. Przy uczeniu się tej umiejętności wybierz jeden typ tarczy: fizyczną lub niefizyczną.",
        tags: [Tag.quick_action, Tag.defensive],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1381,
        name: "Początkowa Tarcza",
        description: "Negujesz pierwsze obrażenia zadane Ci w walce",
        tags: [Tag.quick_action, Tag.defensive],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1480,
        name: "Zachwianie",
        description: "(Wtrącenie) (1 raz na walkę) Wykonaj test sporny na Duszę, w przypadku wygranej możesz anulować akcję przeciwnika związaną z ruchem. np. obladzając jego but",
        tags: [Tag.quick_action, Tag.crowd_control],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1490,
        name: "Ograniczona widoczność",
        description: "(Akcja) Tworzysz obszar zasłaniający wizję przeciwnikom, ale nie sojusznikom, np. mgła, dym. Podtrzymanie 2x2x2m wymaga 1 Many na turę.",
        tags: [Tag.action, Tag.crowd_control, Tag.sustained],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1500,
        name: "Tworzenie",
        description: `W Twojej ręce pojawia się prosty przedmiot, może to być broń, kamień, łopata itp. Podtrzymanie kosztuje manę na turę.
        \n 1 many za przedmiot ogólnodostępny/radzki lub broń zwykłą;
        \n 2 many za przedmiot bardzo rzadki lub broń ekspercką;
        \n 3 many za przedmiot specjalistyczny;
        `,
        tags: [Tag.utils],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1501,
        name: "Filar",
        description: `(Akcja) Manpulujesz terenem tworząc elementy otoczenia lub doły 
        o łącznej wyskości w metrach równej Twojej Duszy, filary utrzymują się przez 5 minut. Każdy metr filara ma 30 życia i Unik 20(stała wartość)`,
        tags: [Tag.utils, Tag.action, Tag.upgrade],
        required: 1500,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1510,
        name: "Powalenie",
        description: `(Akcja) Wykonaj test sporny na Ciało lub Duszę, przeciwko Ostrości przeciwników znajdujących się w promieniu 5 m od Ciebie, Ci którzy przegrali zostają powaleni i nie mogą używać Wtrącenia.`,
        tags: [Tag.crowd_control, Tag.action],
        requirements: {
            body: 1,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1520,
        name: "Pogrzebanie",
        description: `(Akcja) Wygraj test sporny Twoja Dusza Ostrości celu, aby unieruchomić(pogrzebać, zamrozić) przeciwnika,
        jeśli przez 3 kolejne tury cel nie wygra z Tobą testu jego Ciało przeciwko Twojej Duszy zostanie pogrzebana żywcem(umrze).`,
        tags: [Tag.crowd_control, Tag.action, Tag.ulti],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 3
        }
    },
    {
        id: 1530,
        name: "Bariera",
        description: `(Akcja) Tworzysz barierę o długości 2m. Podtrzymanie jej kosztuje 1 many na turę. Bariera posiada 5 punktów życia lub zadaje 3 niechybne obrażenia gdy ktoś wejdzie w nią w interakcje.  
            Za każdy dodatkowo wydany punkty many na podtrzymanie bariery możesz: przedłużyć ją o 2m; zwiększyć jej życie o 5; zwiększyć jej obrażenia o 3 punkty; 
         `,
        tags: [Tag.crowd_control, Tag.action],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1540,
        name: "Ulepszenie przedmiotu",
        description: `(Akcja) Ulepszasz wyekwipowany przez siebie lub sojusznika przedmiot. Bronie zadają obrażenia zwiększone o Twoją Duszę,
         a Pancerze absorbują obrażenia wybrango typu(fizyczne/niefizyczne) równe Twojej Duszy.
         Wzmocnienie jednego przedmiotu wymaga wydania 1 many na turę.`,
        tags: [Tag.buff],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1560,
        name: "Iluzja",
        description: `(Akcja) Tworzysz iluzję nieożywionego obiektu. Podtrzymanie iluzji wymaga 1 Many na turę.
        Postacie które wejdą w interakcję z iluzją wykonują test sporny ich Umysł przeciw Twojemu Duchowi jeśli wygrają są świadome iluzji.`,
        tags: [Tag.utils, Tag.action],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1561,
        name: "Żywa iluzja",
        description: "Potrafisz tworzyć iluzję żywych istot, efekty innych czarów, zmiany pogody itp. Podtrzymanie takiej iluzji wymaga 2 Many na turę.",
        tags: [Tag.utils, Tag.upgrade],
        required: 1560,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1562,
        name: "Klony",
        description: `(Akcja) Raz na walkę możesz stworzyć swoje kolny w ilości równej Twojej Duszy,
         podczas ataku przeciwnik ma równązansę na zaatakowanie ciebie lub jednego z klonów(np. przy 3 klonach jest to 25%). 
        Podtrzymanie 1 klona wymaga 1 Many.`,
        tags: [Tag.utils, Tag.defensive, Tag.upgrade, Tag.once_per_fight],
        required: 1560,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1570,
        name: "Niewidzialność",
        description: "(Akcja) Znikasz. Nadal musisz poruszać się powoli i ostrożnie, żeby nie zostać zauważonym. Przy nagłych ruchach niewidzialność znika. Podtrzymanie wymaga 1 Many.",
        tags: [Tag.utils, Tag.action],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 1
        }
    },
    {
        id: 1580,
        name: "Aura - wrogowie",
        description: `(Akcja) Aktywujesz aurę, która wywołuje stan na wszystkich wrogów, którzy Cię widzą/słyszą. 
        Żeby stan został nałożony na przeciwników wykonaj rzut na Duszę, następnie każdy z nich wykonuje test na Duszę, stan zostaje nałożony na tych którzy mieli gorszy wynik od Twojego.
        Na koniec tury przeciwników rzuty są powtarzane dla tych, którzy nadal mają nałożony stan. Przeciwnicy, którzy raz oparli się aurze są na nią odporni do końca walki lub na 2 godziny.
        Potrzymanie aury kosztuje 1 many.
        `,

        tags: [Tag.crowd_control],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1585,
        name: "Aura - sojusznicy",
        description: `(Akcja) Aktywujesz aurę, która wywołuje stan u wszystkich sojuszników, którzy Cię widzą/słyszą. 
        Stan nakładany jest na 3 tury na sojuszników(ale nie na Ciebie).

        Podtrzymanie aury kosztuje 1 many.
        `,
        tags: [Tag.crowd_control],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1581,
        name: "Niepodatność",
        description: `(Akcja) Aktywujesz niepodatność, pierwsza postać która chce Cię obrać za cel ataku lub umiejętności musi najpierw wygrać z Tobą test sporny na Duszę,
        jeśli jej się to nie uda nie może Cie atakować i obierać za cel w tej turze, jeśli postać wygra z Toba test sporny jest odporna na tą zdolności do końca dnia.
        Podtrzymanie aury wymaga 2 Many. Za wydanie kolejnego punktu many niepodatność zadziała dwa razy w ciągu tury.`,
        tags: [Tag.crowd_control],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 3
        }
    },
    {
        id: 1590,
        name: "Przejęcie kontroli",
        description: `(Akcja) Wygraj test sporny na Duszę z przeciwnikiem którego poziom jest o 4 lub więcej niższy od Twojego, w przypadku wygranej przejmujesz nad nim kontrolę. 
            Żeby nim kierować w kolejnych turach musisz poświęcić akcje.
            Cel ponawia test w momencie gdy otrzyma obrażenia. 
            Po wygranym teście postać staje się odporna na tą zdolności do końca dnia.`,
        tags: [Tag.action, Tag.debuff],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 3
        }
    },
    {
        id: 1600,
        name: "Wielka inicjatywa",
        description: "Po każdej turze, rzuć kością ostrości, przy 1 dostajesz dodatkową turę",
        tags: [Tag.passive, Tag.upgrade],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1610,
        name: "Oznaczenie",
        description: "(Akcja)Jako akcja oznaczasz przeciwnika. Przez 3 kolejne tury wszystkie rzuty przeciw tej postaci wykonujesz z ułatwieniem.",
        tags: [Tag.action, Tag.debuff, Tag.buff],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1611,
        name: "Szybkie oznaczenie",
        description: "Możesz rzucać oznaczenie jako Wtrącenie.",
        tags: [Tag.passive, Tag.upgrade],
        required: 1610,
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1613,
        name: "Leczące oznaczenie",
        description: "Zadanie obrażeń oznaczonemu przeciwnikowi przywraca 2 punkty życia atakującemu. Postać może być uleczona tylko raz w turze przy pomocy tego efektu.",
        tags: [Tag.passive, Tag.upgrade],
        required: 1610,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1614,
        name: "Jawne oznaczenie",
        description: "Efekty oznaczenia aktywują się również dla Twoich sojuszników.",
        tags: [Tag.passive, Tag.upgrade],
        required: 1610,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 2
        }
    },

    {
        id: 1620,
        name: "Atak niefizyczny",
        description: `Wykonaj rzut sporny na Duszę, przy sukcesie zadasz obrażenia niefizyczne równe 4 + stopnie sukcesu.`,
        tags: [Tag.action, Tag.attack],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1621,
        name: "Ulepszony atak niefizyczny",
        description: `"Atak niefizyczny" zadaje teraz 8 + stopnie sukcesu obrażenia niefizyczne`,
        tags: [Tag.support, Tag.attack, Tag.upgrade],
        required: 1620,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1622,
        name: "Wyssanie życia",
        description: `Zdolność "Atak niefizyczny" przywraca Ci przy trafieniu  2*Dusza punkty życia`,
        tags: [Tag.support, Tag.attack, Tag.upgrade],
        required: 1620,
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 1
        }
    },
    {
        id: 1630,
        name: "Zaawansowana broń",
        description: `Jesteś w stanie korzystać z zaawansowanych broni`,
        tags: [],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1631,
        name: "Ekspercka broń",
        description: `Jesteś w stnanie korzystać z eksperckiej broni`,
        tags: [],
        required: 1630,
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1632,
        name: "Mistrzowska broń",
        description: `Jesteś w stnanie korzystać z mistrzowskiej broni`,
        tags: [],
        required: 1631,
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1640,
        name: "Zaawansowany pancerz",
        description: `Jesteś w stnanie korzystać z zaawansowanych pancerzy i tarcz`,
        tags: [Tag.defensive],
        requirements: {
            body: 1,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1641,
        name: "Ekspercki pancerz",
        description: `Jesteś w stnanie korzystać z eksperckiech pancerzy i tarcz`,
        tags: [],
        required: 1640,
        requirements: {
            body: 1,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1642,
        name: "Mistrzowski pancerz",
        description: `Jesteś w stnanie korzystać z mistrzowskich pancerzy i tarcz`,
        tags: [],
        required: 1641,
        requirements: {
            body: 1,
            sharpeness: 0,
            spirit: 0
        }
    },

    {
        id: 1650,
        name: "Dodatkowy unik",
        description: `Dostajesz możliwość wykonania dodatkowego uniku w turze.`,
        tags: [Tag.defensive],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1660,
        name: "Broń dwuręczna w jednej ręce",
        description: `Możesz trzymać broń dwuręczną w jednej ręce`,
        tags: [Tag.offensive, Tag.passive],
        requirements: {
            body: 2,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1670,
        name: "Osłona co turę",
        description: `Na początku swojej tury dostajesz 2 punkty osłony.`,
        tags: [Tag.passive, Tag.defensive],
        requirements: {
            body: 3,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1680,
        name: "Osłona na początku walki",
        description: `Rozpoczynasz walkę z 10-mioma punktami osłony wybranego typu: fizyczna, niefizyczna. Lub z 20 punktami osłony typu: zimno, ogień, porażenie, kłute, obuchowe, sieczne`,
        tags: [Tag.defensive, Tag.passive],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 2
        }
    },
    {
        id: 1690,
        name: "Ulubiony atut",
        description: `Wybierz jeden atut, zakażdym razem gdy nie uda Ci sięzdać testu z jego użyciem możesz go przerzucić.`,
        tags: [Tag.utils],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1700,
        name: "Bezwładność",
        description: `Twoje obrażenia zadawane wręcz są zwiększone o 1 za każde 20 punktów maksymalnego życia.`,
        tags: [Tag.passive, Tag.offensive],
        requirements: {
            body: 2,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1701,
        required: 1700,
        name: "Większa bezwładność",
        description: `Twoje obrażenia zadawane wręcz są zwiększone o 1 za każde 15 punktów maksymalnego życia.`,
        tags: [Tag.passive, Tag.offensive],
        requirements: {
            body: 2,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1702,
        required: 1700,
        name: "Wielka bezwładność",
        description: `Twoje obrażenia zadawane wręcz są zwiększone o 1 za każde 10 punktów maksymalnego życia.`,
        tags: [Tag.passive, Tag.offensive],
        requirements: {
            body: 2,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1710,
        name: "Regeneracja",
        description: `Na początku tury walki regenerujesz 1 punkty życia o wartość równą Twojemu Ciału.`,
        tags: [Tag.defensive],
        requirements: {
            body: 1,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1720,
        name: "Cios w placy",
        description: `Gdy atakujesz postać która nie ma już uniku zadajesz dodatkowe 5 punktów obrażeń.`,
        tags: [Tag.utils],
        requirements: {
            body: 0,
            sharpeness: 1,
            spirit: 0
        }
    },
    {
        id: 1730,
        name: "Szczęście",
        description: `Przysługują Ci dwa przerzuty na sesje.`,
        tags: [Tag.utils],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1740,
        name: "Zawsze przygotowany",
        description: `Twoje zasoby nigdy nie mogą spaść do 0, zatrzymują się na K20.`,
        tags: [Tag.utils],
        requirements: {
            body: 0,
            sharpeness: 0,
            spirit: 0
        }
    },
    {
        id: 1750,
        name: "Kontratak",
        description: `(Wtrącenie) Jeśli udało Ci się uniknąć ataku wręcz, możesz zadać atakującemu obrażenia równe stopniowi sukcesu.`,
        tags: [Tag.attack],
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1751,
        name: "Ulepszony kontratak",
        description: `Przy kontrataku doliczasz obrażenia trzymanej w reku broni.`,
        required: 1750,
        tags: [Tag.attack],
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1752,
        name: "Wytrącenie z równowagi",
        description: `Przy udanym kontrataku przeciwnik Uniki przeciwnika w nastepnej turze redukowane są do K20.`,
        required: 1750,
        tags: [Tag.attack],
        requirements: {
            body: 0,
            sharpeness: 2,
            spirit: 0
        }
    },
    {
        id: 1760,
        name: "Rozkaz",
        description: `(Akcja) Możesz wydać proste polecenie wrogowi, które powinien wykonać gdy przegra test sporny na Duszę. 
        Jeśli celem jest sojusznik możesz wydać mu rozkaz wykonania ataku, ruchu lub wykonania umiejętności bez rzutów, ale będzie go to kosztowało wtrącenie.`,
        tags: [Tag.attack],
        requirements: {
            body: 1,
            sharpeness: 0,
            spirit: 2
        }
    },
]
// odbicie pocisku
// oznaczenie atakiem, możesz jako reackja przmeisścic siędo celu i wykonać atak,
// uśpienie


export const skills = (): SkillDef[] => {
    const map = rawSkills.map(skill => [skill.id, { ...skill }]);

    const topLevelSkills = rawSkills.filter(skill => skill.required == null);

    return topLevelSkills.map(skill => {
        skill.children = rawSkills.filter(subSkill => subSkill.required === skill.id)
        return skill
    }
    )
}

export const skillsMap = new Map(rawSkills.map(item => [item.id, item]))

export const skillCategories = rawSkills.reduce((acc, item) => {
    const category = Tag[item.tags[0]];
    if (!acc[category]) {
        acc[category] = [];
    }
    acc[category].push(item);
    return acc;
}, {} as Record<string, SkillDef[]>);

export const skillsFilterOr = (tags: Tag[]): SkillDef[] => {
    return rawSkills.filter(skill => tags.some(tag => skill.tags.includes(tag)))
}

export const skillsFilterAnd = (tags: Tag[]): SkillDef[] => {
    return rawSkills.filter(skill => tags.every(tag => skill.tags.includes(tag)))
}

export const tags: Tag[] = Object.keys(Tag)
    .filter(key => isNaN(Number(key)))
    .map(key => Tag[key as keyof typeof Tag]) as Tag[];

export const tagName = (tag: Tag) => {
    switch (tag) {
        case Tag.defensive: return "Obrona";
        case Tag.offensive: return "Ofensywa"
        case Tag.attack: return "Walka";
        case Tag.morale: return "Morale";
        case Tag.range: return "Zasięgowe";
        case Tag.utils: return "Użyteczne";
        case Tag.resources: return "Zasoby";
        case Tag.crowd_control: return "Kontrola";
        case Tag.cooperation: return "Kooperacja";
        case Tag.sustained: return "Podtrzymanie";
        case Tag.support: return "Pomaganie";
        case Tag.stack: return "Nakładający się efekt";
        case Tag.upgradeable: return "Rozwijalne";
        case Tag.passive: return "Pasywna";
        case Tag.can_learn_few_times: return "Naucz się wielokrotnie";
        case Tag.action: return "Akcja";
        case Tag.buff: return "Wzmocnienie";
        case Tag.upgrade: return "Rozwinięcie";
        case Tag.aura: return "Aura";
        case Tag.debuff: return "Osłabienie";
        case Tag.melee: return "Zwarcie";
        case Tag.once_per_fight: return "Raz na walkę";
        case Tag.quick_action: return "Wtrącenie";
        
    }
}

const general = rawSkills.filter(t => t.required == null).filter(t => t.requirements.body == 0  && t.requirements.sharpeness == 0 && t.requirements.spirit == 0)

console.log(`skills`)
console.log(`general: ${general.length}`)
general.forEach(i => console.log(i.name))